/** SSR 安全的 localStorage 包装 */
const noopStorage: Storage = {
  length: 0,
  clear() {},
  getItem() { return null },
  key() { return null },
  removeItem() {},
  setItem() {},
}

export const safeLocalStorage: Storage =
  typeof localStorage !== 'undefined' ? localStorage : noopStorage

export const isBrowser = typeof window !== 'undefined'
